import React from 'react';
import { getInnovationTextClasses } from '../../../configs/colors';

export default function ScannerHeading() {
  return (
    <h1 className="text-center font-bold text-4xl md:text-5xl text-white leading-tight">
      <span className={getInnovationTextClasses()}>Business Card</span> Management
      <br />
      <span className="block mt-6 text-white">
        Scan, extract, update, and search business cards
      </span>
    </h1>
  );
}

